import { isEmpty } from 'lodash';
import { apiService } from 'adapters/apiService';
import { API_ERROR_MSG, METHOD, PATHS } from 'adapters/constants';
import { validateCompanyAndStore } from 'adapters/utils';
import {
  InvoiceState,
  InvoiceStatePayload
} from 'pages/VendorsTablePage/components/VendorsTable/types';
import type { HeaderData } from 'adapters/types';
import type {
  PaymentApprovalPayload,
  AuthorizePaymentPayload
} from 'pages/AuthorizePaymentPage/types';

export const postPaymentApproval = async (
  reqObj: PaymentApprovalPayload,
  headers: HeaderData,
  storeId: string,
  companyId: string
): Promise<void> => {
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getApCheckApprovalsPath(companyId),
    method: METHOD.POST,
    reqObj,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response?.ok) throw new Error(response.statusText);
};

export const updatePaymentIsAuthorized = async (
  reqObj: AuthorizePaymentPayload,
  headers: HeaderData,
  storeId: string,
  companyId: string,
  isAuthorized: boolean
): Promise<string> => {
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getPrintIsAuthorizedPath(companyId),
    method: METHOD.POST,
    reqObj,
    headers: { ...headers, 'x-store-id': storeId },
    qsObject: { isAuthorized }
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.text();
};

export const updateInvoiceState = async (
  headers: HeaderData,
  storeId: string,
  state: InvoiceState,
  reqObj: InvoiceStatePayload
): Promise<void> => {
  if (isEmpty(storeId)) {
    throw new Error(API_ERROR_MSG.MISSING_STORE_ID);
  }
  const response = await apiService({
    url: PATHS.getInvoiceStatePath(storeId, state),
    method: METHOD.POST,
    headers: { ...headers, 'x-store-id': storeId },
    reqObj
  });
  if (!response?.ok) throw new Error(response.statusText);
};
